import lazysizes from 'lazysizes'
import 'lazysizes/plugins/bgset/ls.bgset'

lazysizes.cfg.lazyClass = 'js-lazy'

document.addEventListener('lazybeforeunveil', (event) => {
  const source = event.target.getAttribute('data-bg')
  if (source) event.target.style.backgroundImage = `url(${source})`
})
